import React from 'react';
import classNames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';
import { transition } from 'lib/helpers';
import { FirstChild } from './FirstChild';

export class MetaInfo extends React.Component {
	state = {
		collapsed: this.props.defaultCollapsed
	}

	render() {
		const { extra = '更多信息', metas } = this.props;
		const { collapsed } = this.state;

		if (!metas || !metas.length) {
			return;
		}

		const [first, ...rest] = metas;

		return (
			<div className="meta-info">
				{rest.length > 0 &&
					<div className="meta-head">
						<a href="javascript:void(0);" onClick={this.toggle}>
							<i className={classNames('qa-ico-down-expand', { collapsed })} />
						</a>
					</div>
				}
				<div className="meta-content">
					<ul>
						<li
							key="first"
							style={{ cursor: rest.length ? 'pointer' : null }}
							onClick={this.toggle}>
							<MetaItem {...first} />
						</li>
						{rest.length > 0 &&
							<CSSTransitionGroup
								component={FirstChild}
								{...transition.slide({ enterPosition: { x: 0, y: -10 } })}>
								{!collapsed && rest.map((meta, idx) => (
									<li key={idx}><MetaItem {...meta} /></li>
								))}
							</CSSTransitionGroup>
						}
					</ul>
				</div>
			</div>
		);
	}

	toggle = (evt) => this.setState({ collapsed: !this.state.collapsed });
}

function MetaItem({ type, text, url }) {
	switch (type) {
		case 'link':
			return <a target="_blank" href={url} onClick={evt => evt.stopPropagation()}>{text}</a>;
		case 'text':
		default:
			return text;
	}
}



// WEBPACK FOOTER //
// ./lib/components/MetaInfo.jsx